/*!
 * OGGON Share — premium product sharing
 * -------------------------------------
 * Adds a share button beneath every wishlist heart (so it appears on every
 * product image the wishlist already found: cards, rails, search, product
 * page) and opens a share sheet with WhatsApp, Facebook, X, LinkedIn,
 * Telegram, Pinterest, Email, Copy link and the device's native share.
 *
 * - Product data is fetched from Shopify's own /products/<handle>.js on
 *   first use and cached, so the sheet always shows the live title, price
 *   and image.
 * - Shared links carry utm_source=share&utm_medium=<channel> so shares show
 *   up in analytics.
 * - Back button / Esc / scrim tap closes the sheet. Focus is trapped while
 *   open and returned to the button afterwards.
 * - Single global instance; safe under theme-editor section re-renders.
 */
(function () {
  'use strict';

  if (window.__oggonShareInit) { return; }
  window.__oggonShareInit = true;

  var CFG = window.OggonShareConfig || {};
  var SHOP = CFG.shopName || 'OGGON';
  var ORIGIN = CFG.origin || (window.location.protocol + '//' + window.location.host);
  var cache = {};

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(paise) {
    var n = Math.round((parseFloat(paise) || 0) / 100);
    return '₹' + n.toLocaleString('en-IN');
  }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') { window.gtag('event', name, params || {}); } } catch (e) {}
    try { if (window.dataLayer && window.dataLayer.push) { window.dataLayer.push(Object.assign({ event: name }, params || {})); } } catch (e) {}
  }

  var ICON_SHARE = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  var ICON_LINK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.1 0l2.8-2.8a5 5 0 0 0-7.1-7.1L11.5 4.4"/><path d="M14 11a5 5 0 0 0-7.1 0l-2.8 2.8a5 5 0 0 0 7.1 7.1l1.3-1.3"/></svg>';
  var ICON_ARROW = '<svg class="oggon-sh-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var ICON_COPY = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h9"/></svg>';
  var ICONS = {
    wa: '<svg viewBox="0 0 24 24"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.2 5.07 4.49.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35z"/><path d="M12.04 2C6.6 2 2.18 6.42 2.18 11.86c0 1.74.46 3.44 1.32 4.94L2.1 22l5.34-1.4a9.83 9.83 0 0 0 4.6 1.17h.01c5.44 0 9.86-4.42 9.86-9.86C21.91 6.42 17.48 2 12.04 2zm0 17.99h-.01a8.2 8.2 0 0 1-4.17-1.14l-.3-.18-3.1.81.83-3.02-.2-.31a8.16 8.16 0 0 1-1.25-4.36c0-4.52 3.68-8.19 8.2-8.19 2.19 0 4.25.85 5.8 2.4a8.14 8.14 0 0 1 2.4 5.8c0 4.52-3.68 8.19-8.2 8.19z"/></svg>',
    fb: '<svg viewBox="0 0 24 24"><path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.8c0-.9.3-1.6 1.6-1.6h1.7V4.4c-.3 0-1.3-.1-2.4-.1-2.4 0-4.1 1.5-4.1 4.2v2.3H7.6V14h2.7v8h3.2z"/></svg>',
    x: '<svg viewBox="0 0 24 24"><path d="M17.5 3h3l-6.8 7.8L21.7 21h-6.2l-4.9-6.4L5 21H2l7.3-8.3L1.7 3H8l4.4 5.8L17.5 3zm-1.1 16.2h1.7L7.4 4.7H5.6l10.8 14.5z"/></svg>',
    'in': '<svg viewBox="0 0 24 24"><path d="M6.5 8.5H3.2V21h3.3V8.5zM4.9 3a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 0 0 0-3.8zM21 13.3c0-3.6-1.9-5.2-4.5-5.2-2 0-2.9 1.1-3.4 1.9V8.5H9.8V21h3.3v-6.9c0-1.8.7-3 2.3-3s2.2 1.2 2.2 3V21H21v-7.7z"/></svg>',
    tg: '<svg viewBox="0 0 24 24"><path d="M21.5 3.6L2.9 10.8c-1.3.5-1.3 1.2-.2 1.5l4.8 1.5 11-6.9c.5-.3 1-.1.6.2l-8.9 8.1-.3 4.9c.5 0 .7-.2 1-.5l2.3-2.3 4.9 3.6c.9.5 1.5.2 1.8-.8L23.1 5c.3-1.3-.5-1.9-1.6-1.4z"/></svg>',
    pin: '<svg viewBox="0 0 24 24"><path d="M12 2C6.5 2 3 6 3 10.3c0 2 1.1 4.6 2.8 5.4.3.1.4 0 .5-.2l.4-1.7c0-.2 0-.3-.1-.5-.6-.7-1.1-2-1.1-3.2 0-3.1 2.4-6.1 6.4-6.1 3.5 0 5.9 2.4 5.9 5.8 0 3.8-1.9 6.5-4.4 6.5-1.4 0-2.4-1.1-2.1-2.5.4-1.7 1.2-3.5 1.2-4.7 0-1.1-.6-2-1.8-2-1.4 0-2.6 1.5-2.6 3.5 0 1.3.4 2.1.4 2.1l-1.7 7.3c-.3 1.2-.2 2.9-.1 4 .1.1.2.1.3 0 .3-.5 2-2.9 2.4-4.4l.9-3.5c.5.9 1.8 1.6 3.2 1.6 4.3 0 7.3-3.9 7.3-8.8C21 5.6 17.2 2 12 2z"/></svg>',
    mail: '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M3.5 7l8.5 6 8.5-6"/></svg>',
    more: '<svg viewBox="0 0 24 24"><path d="M12 3v12M8 7l4-4 4 4"/><path d="M5 12v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>'
  };

  function loadProduct(handle) {
    if (cache[handle]) { return Promise.resolve(cache[handle]); }
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('http'); } return r.json(); })
      .then(function (p) {
        var v = p.variants && p.variants[0];
        var slim = {
          handle: handle,
          title: p.title,
          url: ORIGIN + '/products/' + handle,
          image: p.featured_image || (p.images && p.images[0]) || '',
          price: v ? v.price : p.price,
          compare: v && v.compare_at_price > v.price ? v.compare_at_price : 0
        };
        cache[handle] = slim;
        return slim;
      });
  }

  function thumb(url, size) {
    if (!url) { return ''; }
    var u = String(url).replace(/([?&])width=\d+/, '$1');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
  }

  function shareUrl(p, channel) {
    return p.url + '?utm_source=share&utm_medium=' + channel + '&utm_campaign=product_share';
  }
  function shareText(p) {
    var off = p.compare ? Math.round((p.compare - p.price) * 100 / p.compare) : 0;
    return p.title + ' — ' + money(p.price) + (off ? ' (' + off + '% off)' : '') + ' at ' + SHOP + '. 3-year warranty, free delivery across India.';
  }

  function targets(p) {
    var t = shareText(p);
    return [
      { key: 'wa', label: 'WhatsApp', href: 'https://wa.me/?text=' + encodeURIComponent(t + '\n' + shareUrl(p, 'whatsapp')) },
      { key: 'fb', label: 'Facebook', href: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl(p, 'facebook')) },
      { key: 'x', label: 'X', href: 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(t) + '&url=' + encodeURIComponent(shareUrl(p, 'x')) },
      { key: 'in', label: 'LinkedIn', href: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(shareUrl(p, 'linkedin')) },
      { key: 'tg', label: 'Telegram', href: 'https://t.me/share/url?url=' + encodeURIComponent(shareUrl(p, 'telegram')) + '&text=' + encodeURIComponent(t) },
      { key: 'pin', label: 'Pinterest', href: 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(shareUrl(p, 'pinterest')) + '&media=' + encodeURIComponent(p.image || '') + '&description=' + encodeURIComponent(p.title) },
      { key: 'mail', label: 'Email', href: 'mailto:?subject=' + encodeURIComponent('Have a look at this chair: ' + p.title) + '&body=' + encodeURIComponent(t + '\n\n' + shareUrl(p, 'email')), stroke: true },
      { key: 'more', label: 'More', native: true, stroke: true }
    ];
  }

  var overlay, sheet, toast, lastFocus = null, current = null, pushed = false, toastTimer = null;

  function buildSheet() {
    overlay = document.createElement('div');
    overlay.className = 'oggon-sh-overlay';
    overlay.hidden = true;
    overlay.setAttribute('data-oggon-wl-skip', '');
    overlay.addEventListener('click', function () { close(false); });

    sheet = document.createElement('div');
    sheet.className = 'oggon-sh-sheet';
    sheet.hidden = true;
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Share this chair');
    sheet.setAttribute('data-oggon-wl-skip', '');

    toast = document.createElement('div');
    toast.className = 'oggon-sh-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    document.body.appendChild(overlay);
    document.body.appendChild(sheet);
    document.body.appendChild(toast);

    sheet.addEventListener('click', onSheetClick);
    sheet.addEventListener('keydown', onSheetKey);
    window.addEventListener('popstate', function () { if (!sheet.hidden) { pushed = false; close(true); } });
  }

  function render(p) {
    var off = p.compare ? Math.round((p.compare - p.price) * 100 / p.compare) : 0;
    var list = targets(p);
    var canNative = !!(navigator.share);
    var wa = list[0];
    var rest = list.slice(1);
    var host = ORIGIN.replace(/^https?:\/\//, '');
    var html =
      '<div class="oggon-sh-head">' +
        '<div>' +
          '<p class="oggon-sh-eyebrow"><span>' + esc(SHOP) + '</span>Share</p>' +
          '<h2 class="oggon-sh-title">Share this chair</h2>' +
          '<p class="oggon-sh-sub">Send it to a friend, a colleague or your team.</p>' +
        '</div>' +
        '<button type="button" class="oggon-sh-close" data-sh-close aria-label="Close">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="oggon-sh-prod">' +
        '<div class="oggon-sh-prod__img">' + (p.image ? '<img src="' + esc(thumb(p.image, 300)) + '" alt="">' : '') + '</div>' +
        '<div class="oggon-sh-prod__body">' +
          '<p class="oggon-sh-prod__title">' + esc(p.title) + '</p>' +
          '<p class="oggon-sh-prod__price"><b>' + money(p.price) + '</b>' +
            '<s' + (p.compare ? '' : ' hidden') + '>' + (p.compare ? money(p.compare) : '') + '</s>' +
            '<em' + (off ? '' : ' hidden') + '>' + (off ? off + '% off' : '') + '</em></p>' +
          '<p class="oggon-sh-prod__host">' + ICON_LINK + esc(host) + '/products/' + esc(p.handle) + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="oggon-sh-actions">' +
        '<a class="oggon-sh-primary" href="' + esc(wa.href) + '" target="_blank" rel="noopener" data-sh-key="wa">' +
          '<i>' + ICONS.wa + '</i><span>Send on WhatsApp</span>' + ICON_ARROW +
        '</a>' +
        '<button type="button" class="oggon-sh-native" data-sh-native' + (canNative ? '' : ' hidden') + '>' + ICONS.more + '<span>More apps</span></button>' +
      '</div>' +
      '<p class="oggon-sh-lbl">Or share via</p>' +
      '<div class="oggon-sh-grid">' +
        rest.filter(function (t) { return !t.native; }).map(function (t, i) {
          return '<a class="oggon-sh-ch oggon-sh-ch--' + t.key + (t.stroke ? ' oggon-sh-ch--stroke' : '') + '" style="--i:' + i + '" href="' + esc(t.href) + '" target="_blank" rel="noopener" data-sh-key="' + t.key + '"><i>' + ICONS[t.key] + '</i><span>' + t.label + '</span></a>';
        }).join('') +
      '</div>' +
      '<div class="oggon-sh-copy">' +
        ICON_LINK +
        '<input type="text" readonly value="' + esc(shareUrl(p, 'link')) + '" aria-label="Product link">' +
        '<button type="button" data-sh-copy>' + ICON_COPY + '<span>Copy link</span></button>' +
      '</div>' +
      '<div class="oggon-sh-foot">' +
        '<span><svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"/></svg>3-year warranty</span>' +
        '<span><svg viewBox="0 0 24 24"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>Free delivery India</span>' +
        '<span><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>BIFMA-tested</span>' +
        '<span><svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18"/></svg>GST invoice</span>' +
      '</div>';
    sheet.innerHTML = html;
  }

  function open(p, trigger) {
    if (!sheet) { buildSheet(); }
    current = p;
    lastFocus = trigger || document.activeElement;
    render(p);
    overlay.hidden = false;
    sheet.hidden = false;
    document.body.classList.add('oggon-sh-locked');
    // eslint-disable-next-line no-unused-expressions
    sheet.offsetHeight;
    overlay.classList.add('is-open');
    sheet.classList.add('is-open');
    if (!pushed) { try { history.pushState({ oggonShare: 1 }, ''); pushed = true; } catch (e) {} }
    setTimeout(function () { var c = sheet.querySelector('.oggon-sh-close'); if (c) { c.focus(); } }, 60);
    track('share_open', { item_id: p.handle, item_name: p.title });
  }

  function close(fromPop) {
    if (!sheet || sheet.hidden) { return; }
    overlay.classList.remove('is-open');
    sheet.classList.remove('is-open');
    document.body.classList.remove('oggon-sh-locked');
    setTimeout(function () { overlay.hidden = true; sheet.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    if (pushed) { pushed = false; if (!fromPop) { try { history.back(); } catch (e) {} } }
  }

  function showToast(msg) {
    toast.innerHTML = ICON_CHECK + '<span>' + esc(msg) + '</span>';
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-open'); }, 2200);
  }

  function copyLink(btn) {
    var url = shareUrl(current, 'link');
    var done = function () {
      btn.classList.add('is-done');
      btn.querySelector('span').textContent = 'Copied';
      showToast('Link copied');
      track('share', { method: 'copy_link', item_id: current.handle });
      setTimeout(function () { btn.classList.remove('is-done'); btn.querySelector('span').textContent = 'Copy link'; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { legacyCopy(url); done(); });
    } else { legacyCopy(url); done(); }
  }
  function legacyCopy(text) {
    var inp = sheet.querySelector('.oggon-sh-copy input');
    try { inp.focus(); inp.select(); document.execCommand('copy'); } catch (e) {}
  }

  function nativeShare() {
    if (!navigator.share || !current) { return; }
    navigator.share({ title: current.title, text: shareText(current), url: shareUrl(current, 'native') })
      .then(function () { track('share', { method: 'native', item_id: current.handle }); close(false); })
      .catch(function () {});
  }

  function onSheetClick(e) {
    var t = e.target;
    if (t.closest('[data-sh-close]')) { close(false); return; }
    if (t.closest('[data-sh-copy]')) { copyLink(t.closest('[data-sh-copy]')); return; }
    if (t.closest('[data-sh-native]')) { nativeShare(); return; }
    var ch = t.closest('a[data-sh-key]');
    if (ch) {
      track('share', { method: ch.getAttribute('data-sh-key'), item_id: current && current.handle });
      var href = ch.getAttribute('href');
      if (href.indexOf('mailto:') !== 0) {
        e.preventDefault();
        window.open(href, 'oggon_share', 'width=640,height=560,menubar=no,toolbar=no,noopener');
      }
    }
  }

  function onSheetKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(false); return; }
    if (e.key === 'Tab') {
      var f = qsa('a[href],button:not([disabled]),input', sheet).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) { return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function buildButton(handle, isPdp) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'oggon-sh-btn' + (isPdp ? ' oggon-sh-btn--pdp' : '');
    b.setAttribute('data-oggon-share', handle);
    b.setAttribute('aria-label', 'Share this chair');
    b.setAttribute('title', 'Share');
    b.innerHTML = ICON_SHARE;
    return b;
  }

  function attachTo(heart) {
    if (heart.getAttribute('data-sh-done')) { return; }
    var handle = heart.getAttribute('data-oggon-wl-handle');
    if (!handle || !heart.parentElement) { return; }
    if (heart.closest('.oggon-wl-drawer, .oggon-wl-toast, .oggon-wl-item, .oggon-rp')) { return; }
    heart.setAttribute('data-sh-done', '1');
    var isPdp = heart.classList.contains('oggon-wl-heart--pdp');
    var btn = buildButton(handle, isPdp);
    heart.parentElement.insertBefore(btn, heart.nextSibling);
  }

  function scan(root) {
    qsa('.oggon-wl-heart[data-oggon-wl-handle]', root || document).forEach(attachTo);
  }

  function reconcile() {
    qsa('.oggon-sh-btn').forEach(function (btn) {
      var handle = btn.getAttribute('data-oggon-share');
      var heart = btn.previousElementSibling;
      if (heart && heart.classList.contains('oggon-wl-heart') && heart.getAttribute('data-oggon-wl-handle') === handle) { return; }
      var parent = btn.parentElement;
      var real = parent ? parent.querySelector('.oggon-wl-heart[data-oggon-wl-handle="' + handle + '"]') : null;
      if (real) { parent.insertBefore(btn, real.nextSibling); return; }
      var moved = document.querySelector('.oggon-wl-heart[data-oggon-wl-handle="' + handle + '"][data-sh-done]');
      if (moved && moved.parentElement && !moved.nextElementSibling) { moved.parentElement.insertBefore(btn, moved.nextSibling); }
      else if (!moved) { btn.remove(); }
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-oggon-share]');
    if (!b) { return; }
    e.preventDefault();
    e.stopPropagation();
    var handle = b.getAttribute('data-oggon-share');
    var seed = { handle: handle, title: document.title, url: ORIGIN + '/products/' + handle, image: '', price: 0, compare: 0 };
    loadProduct(handle).then(function (p) { open(p, b); }, function () { open(seed, b); });
  }, true);

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) { return; }
    scheduled = true;
    setTimeout(function () { scheduled = false; scan(); reconcile(); }, 120);
  }

  function boot() {
    scan();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleScan(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', scheduleScan);
    window.addEventListener('load', scheduleScan);
    setTimeout(scheduleScan, 1500);
    setTimeout(scheduleScan, 4000);
  }

  window.OggonShare = { open: function (handle) { loadProduct(handle).then(function (p) { open(p, null); }); }, close: function () { close(false); } };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
